import { Accessor } from 'solid-js';
import { FieldType, FormFieldContext } from '../forms-types';
import { Comment, TextArea, TextField, TextInput } from './text-fields';
import { CommunicationPreferenceSelect, CountrySelect, Dropdown, UserTypeSelect } from './selects';
import { CheckboxGroup, RadioButtons } from './choice-groups';
import { HiddenFields } from './hidden-fields';

type FormFieldProps = {
    field: FieldType;
    ctx: FormFieldContext;
    stepFields: FieldType[];
    forceRequire?: Accessor<boolean>;
};

// `field` and `ctx` are stable for the lifetime of this component instance
// (each <FormField> is keyed by reference inside <For>), so a one-time switch
// on field.slug is correct — slug never changes for a given mount.
export const FormField = (props: FormFieldProps) => {
    switch (props.field.slug) {
        case 'country':
            return <CountrySelect field={props.field} ctx={props.ctx} />;
        case 'hiddenField':
            return <HiddenFields stepFields={props.stepFields} />;
        case 'userType':
            return <UserTypeSelect field={props.field} ctx={props.ctx} />;
        case 'comments':
            return <Comment field={props.field} ctx={props.ctx} />;
        case 'communicationPreference':
            return <CommunicationPreferenceSelect field={props.field} ctx={props.ctx} />;
        case 'customDropdown':
            return <Dropdown field={props.field} ctx={props.ctx} />;
        case 'customTextField':
            return <TextField field={props.field} ctx={props.ctx} />;
        case 'customRadioButtons':
            return <RadioButtons field={props.field} ctx={props.ctx} />;
        case 'customCheckbox':
            return <CheckboxGroup field={props.field} ctx={props.ctx} />;
        case 'textArea':
            return <TextArea field={props.field} ctx={props.ctx} />;
        default:
            return <TextInput field={props.field} ctx={props.ctx} forceRequire={props.forceRequire} />;
    }
};
